import {ValueObject} from '@s-ui/domain'

import {IndicatorPriceValueObject} from './IndicatorPriceValueObject.js'
import {TaxPriceValueObject} from './TaxPriceValueObject.js'

export class PriceValueObject extends ValueObject {
  #amount
  #financedAmount
  #indicator
  #tax

  constructor({amount, financedAmount, indicator, tax}) {
    super()
    this.#amount = amount
    this.#financedAmount = financedAmount
    this.#indicator = indicator
    this.#tax = tax
  }

  static createFromListingApi({price}) {
    const indicatorPriceValueObject = IndicatorPriceValueObject.createFromListingApi({
      indicator: price.indicator || {}
    })

    const taxPriceValueObject = TaxPriceValueObject.createFromListingApi({
      hasTaxes: price.hasTaxes,
      taxTypeId: price.taxTypeId
    })

    return new PriceValueObject({
      amount: price.amount,
      financedAmount: price.financedAmount,
      indicator: indicatorPriceValueObject,
      tax: taxPriceValueObject
    })
  }

  get amount() {
    return this.#amount
  }

  get financedAmount() {
    return this.#financedAmount
  }

  get indicator() {
    return this.#indicator.value
  }

  get tax() {
    return this.#tax.value
  }

  get value() {
    return {amount: this.amount, financedAmount: this.financedAmount, indicator: this.indicator, tax: this.tax}
  }
}
